/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList, Label } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { FormControl, Button, IconButton, Box, Typography, Avatar, FormControlLabel, Switch, FormHelperText } from '@mui/material';
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import { IAutocompleteOption } from '../../../../models/iautocompleteOption';
import { RootState } from '../../../../store/types';
import { IEquipment } from '../../../../models/iequipment';
import getAccountablesNamesFormatted from '../../../../utils/getAccountablesNamesFormatted';

type Props = {
  closeModal: CallableFunction,
	resetPage: CallableFunction,
}

export interface IEquipmentOption {
	value: string;
	label: string;
	// equipment: IEquipment;
	equipment: any;
}

export enum EServiceStatus {
	noService = "noService",
	overdue = "overdue",
	valid = "valid",
};

const serviceStatus = [
	{ value: EServiceStatus.noService, label: i18n.t(`scheduledServicesServicesForSchedulingFilterModal.noService`) },
	{ value: EServiceStatus.overdue, label: i18n.t(`scheduledServicesServicesForSchedulingFilterModal.overdue`) },
	{ value: EServiceStatus.valid, label: i18n.t(`scheduledServicesServicesForSchedulingFilterModal.valid`) },
];

const ServicesForSchedulingFiltersModal: React.FC<Props> = (props) => {
	const dispatch = useDispatch();

	const page = 1;
	const limit = 30;
	const orderBy = "name";
	const order = "asc";

	const [searchTextEquipmentModels, setSearchTextEquipmentModels] = useState('');
	const [equipmentModelsFormated, setEquipmentModelsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedEquipmentModels, setSelectedEquipmentModels] = useState<IAutocompleteOption[]>([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedPlaces, setSelectedPlaces] = useState<IAutocompleteOption[]>([]);

	const [searchTextGroup, setSearchTextGroup] = useState('');
	const [groupsFormated, setGroupsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedGroups, setSelectedGroups] = useState<IAutocompleteOption[]>([]);

  const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedAreas, setSelectedAreas] = useState<IAutocompleteOption[]>([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedCompanies, setSelectedCompanies] = useState<IAutocompleteOption[]>([]);

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState<IEquipmentOption[]>([]);
	const [selectedEquipments, setSelectedEquipments] = useState<IEquipmentOption|null>(null);

  const [searchTextFrequencies, setSearchTextFrequencies] = useState('');
	const [frequenciesFormated, setFrequenciesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedFrequencies, setSelectedFrequencies] = useState<IAutocompleteOption[]>([]);
  
  const [searchTextServiceTypes, setSearchTextServiceTypes] = useState('');
	const [serviceTypesFormated, setServiceTypesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedServiceTypes, setSelectedServiceTypes] = useState<IAutocompleteOption[]>([]);

	const [selectedServiceStatus, setSelectedServiceStatus] = useState<EServiceStatus[]>([]);

	const [startDate, setStartDate] = useState<Date|null>(null);
	const [endDate, setEndDate] = useState<Date|null>(null);

	const selectedSiteId = useSelector((state: RootState) => state.scheduledServices.selectedSiteId);

	const fetchPlaces = useCallback(
		() => dispatch(actions.scheduledServicesFetchPlaces(selectedSiteId)),
		[selectedSiteId]
	);

	const fetchEquipmentModels = useCallback(
		() => dispatch(actions.scheduledServicesFetchEquipmentModels(page, limit, searchTextEquipmentModels, order, orderBy)),
		[page, limit, searchTextEquipmentModels, order, orderBy]
	);

	const fetchGroups = useCallback(
		() => dispatch(actions.scheduledServicesFetchGroups(page, limit, searchTextGroup, order, orderBy)),
		[page, limit, searchTextGroup, order, orderBy]
	);

  const fetchAreas = useCallback(
		() => dispatch(actions.scheduledServicesFetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.scheduledServicesFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

  const fetchServiceTypes = useCallback(
		() => dispatch(actions.scheduledServicesFetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy)),
		[page, limit, searchTextServiceTypes, order, orderBy]
	);

	const fetchFrequencies = useCallback(
		() => dispatch(actions.scheduledServicesFetchFrequencies(page, limit, searchTextFrequencies, order, orderBy)),
		[page, limit, searchTextFrequencies, order, orderBy]
	);

  const role = useSelector((state: any) => state.auth.selectedAccess.role);

	const places = useSelector((state: RootState) => state.scheduledServices.places);
	const equipmentsModels = useSelector((state: RootState) => state.scheduledServices.equipmentModels);
	const groups = useSelector((state: RootState) => state.scheduledServices.equipmentGroups);
	const areas = useSelector((state: RootState) => state.scheduledServices.areas);
	const companies = useSelector((state: RootState) => state.scheduledServices.companies);
  const frequencies = useSelector((state: RootState) => state.scheduledServices.frequencies);
  const serviceTypes = useSelector((state: RootState) => state.scheduledServices.serviceTypes);
	const equipments = useSelector((state: RootState) => state.scheduledServices.equipments);

	const filteredPlaces = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.places);
	const filteredEquipmentsModels = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.equipmentModels);
	const filteredGroups = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.equipmentGroups);
	const filteredAreas = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.areas);
	const filteredCompanies = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.companies);
  const filteredFrequencies = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.frequencies);
  const filteredServiceTypes = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.serviceTypes);
	const filteredStartDate = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.startDate);
	const filteredEndDate = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.endDate);
	const filteredEquipments = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.equipment);
	const filteredServiceStatus = useSelector((state: RootState) => state.scheduledServices.filtersServicesForScheduling.serviceStatus);

	const loadingEquipmentModels = useSelector((state: RootState) => state.scheduledServices.loadingEquipmentModels);
	const loadingPlaces = useSelector((state: RootState) => state.scheduledServices.loadingPlaces);
	const loadingGroups = useSelector((state: RootState) => state.scheduledServices.loadingEquipmentGroups);
	const loadingAreas = useSelector((state: RootState) => state.scheduledServices.loadingAreas);
	const loadingCompanies = useSelector((state: RootState) => state.scheduledServices.loadingCompanies);
  const loadingFrequencies = useSelector((state: RootState) => state.scheduledServices.loadingFrequencies);
  const loadingServiceTypes = useSelector((state: RootState) => state.scheduledServices.loadingServiceTypes);
	const loadingEquipments = useSelector((state: RootState) => state.scheduledServices.loadingEquipments);

	const fetchEquipments = useCallback(
		() => dispatch(actions.scheduledServicesFetchEquipments(page, limit, searchTextEquipment, order, 'equipmentModel.name', [{_id: selectedSiteId}] as any, filteredPlaces, filteredEquipmentsModels, filteredGroups, filteredAreas, filteredCompanies)),
		[page, limit, searchTextEquipment, order, orderBy, selectedSiteId, filteredPlaces, filteredEquipmentsModels, filteredGroups, filteredAreas, filteredCompanies]
	);

	useEffect(() => {
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeEquipmentsModels(filteredEquipmentsModels);
		handleInputChangeGroups(filteredGroups);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
    handleInputChangeFrequencies(filteredFrequencies);
    handleInputChangeServiceTypes(filteredServiceTypes);
		handleInputChangeEquipments(filteredEquipments);
		setSelectedServiceStatus(filteredServiceStatus);
		setStartDate(filteredStartDate);
		setEndDate(filteredEndDate)
	}, []);

	useEffect(() => {
		fetchPlaces();
	}, [selectedSiteId]);

	useEffect(() => {
		fetchEquipments();
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchEquipmentModels();
	}, [searchTextEquipmentModels]);

	useEffect(() => {
		fetchGroups();
	}, [searchTextGroup]);

  useEffect(() => {
		fetchAreas();
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies();
    }
	}, [searchTextCompanies]);

  useEffect(() => {
		fetchFrequencies();
	}, [searchTextFrequencies]);

  useEffect(() => {
		fetchServiceTypes();
	}, [searchTextServiceTypes]);

	useEffect(() => {
		setPlacesFormated(
			places.map((place) => ({ value: place._id, label: place.path }))
		)
	}, [places])

	useEffect(() => {
		setEquipmentModelsFormated(
			equipmentsModels.map((equipmentModel) => ({ value: equipmentModel._id, label: equipmentModel.name }))
		)
	}, [equipmentsModels])

	useEffect(() => {
		setEquipmentsFormated(
			equipments.map((equipment) => ({ value: equipment._id, label: equipment.equipmentModel.name, equipment }))
		)
	}, [equipments])

	useEffect(() => {
		setGroupsFormated(
			groups.map((group) => ({ value: group._id, label: group.name }))
		)
	}, [groups])

  useEffect(() => {
		setAreasFormated(
			areas.map((area) => ({ value: area._id, label: area.name }))
		)
	}, [areas])

	useEffect(() => {
		setCompaniesFormated(
			companies.map((company) => ({ value: company._id, label: company.name }))
		)
	}, [companies])

  useEffect(() => {
		setFrequenciesFormated(
			frequencies.map((frequency) => ({ value: frequency._id, label: frequency.name }))
		)
	}, [frequencies])

  useEffect(() => {
		setServiceTypesFormated(
			serviceTypes.map((serviceType) => ({ value: serviceType._id, label: serviceType.name }))
		)
	}, [serviceTypes])

	const handleInputChangeSelectorPlaces = (text: string) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorEquipmentsModels = (text: string) => {
		setSearchTextEquipmentModels(text);
	}

	const handleInputChangeSelectorEquipments = (text: string) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorGroups = (text: string) => {
		setSearchTextGroup(text);
	}

	const handleInputChangeSelectorAreas = (text: string) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text: string) => {
		setSearchTextCompanies(text);
	}

  const handleInputChangeSelectorFrequencies = (text: string) => {
		setSearchTextFrequencies(text);
	}

  const handleInputChangeSelectorServiceTypes = (text: string) => {
		setSearchTextServiceTypes(text);
	}

	const handleInputChangeGroups = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedGroups(selected);
		} else {
			setSelectedGroups([]);
		}
	}

  const handleInputChangeAreas = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedAreas(selected);
		} else {
			setSelectedAreas([]);
		}
	}

	const handleInputChangePlaces = (selected: IAutocompleteOption[])=> {
		if (selected) {
			setSelectedPlaces(selected);
		} else {
			setSelectedPlaces([]);
		}
	}

	const handleInputChangeEquipmentsModels = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedEquipmentModels(selected);
		} else {
			setSelectedEquipmentModels([]);
		}
	}

	const handleInputChangeCompanies = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedCompanies(selected);
		} else {
			setSelectedCompanies([]);
		}
	}

	const handleInputChangeEquipments = (selected: IEquipmentOption|null) => {
		setSelectedEquipments(selected);
	}

  const handleInputChangeFrequencies = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedFrequencies(selected);
		} else {
			setSelectedFrequencies([]);
		}
	}

  const handleInputChangeServiceTypes = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedServiceTypes(selected);
		} else {
			setSelectedServiceTypes([]);
		}
	}

	const handleChangeStatus = (status: EServiceStatus, checked: boolean) => {
		const serviceStatusCopy = [...selectedServiceStatus];
		if (checked) {
			serviceStatusCopy.push(status)
		} else {
			const copyIndex = serviceStatusCopy.findIndex((statuscopy) => statuscopy === status);
			serviceStatusCopy.splice(copyIndex, 1);
		}
		setSelectedServiceStatus(serviceStatusCopy);
	}

	const isStatusChecked = (status: EServiceStatus) => {
		return selectedServiceStatus.some((selectedStatus) => selectedStatus === status);
	}


	const handleClickFilter = () => {
		dispatch(actions.scheduledServicesSetServicesForSchedulingFilters({
			equipmentModels: selectedEquipmentModels,
			areas: selectedAreas,
      companies: selectedCompanies,
      equipmentGroups: selectedGroups,
      frequencies: selectedFrequencies, 
      places: selectedPlaces,
      serviceTypes: selectedServiceTypes,
			startDate,
			endDate,
			equipment: selectedEquipments,
			serviceStatus: selectedServiceStatus,
		}))
		props.resetPage();
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([]);
		setSelectedEquipmentModels([]);
		setSelectedGroups([]);
		setSelectedAreas([]);
		setSelectedCompanies([]);
    setSelectedFrequencies([]);
    setSelectedServiceTypes([]);
	}

	const EquipmentOption = ({ value, label, equipment }: IEquipmentOption) => {
    if (!equipment) return

    return (
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
				 {equipment.photo?.url ?
        <Avatar src={equipment.photo?.url} sx={styles.avatar} />
        :
        <Avatar sx={styles.avatarSmallText}>
          PHOTO
        </Avatar>
      }
				<Box sx={{marginLeft: '10px'}}>
					<Typography sx={{ fontWeight: 'bold' }}>{label}</Typography>
					<Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.serialNumber') as string}{equipment.serialNumber}</Typography>
					<Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.place') as string}{equipment.place.path}</Typography>
				</Box>
      </Box>
    )
  }

	const StatusOption = (props: {value: EServiceStatus, label: string}) => {
		return (
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
				<Typography>{props.label}</Typography>
				<Typography sx={{ fontSize: 12 }}>{i18n.t(`scheduledServicesServicesForSchedulingFilterModal.${props.value}HelperText`) as string}</Typography>
      </Box>
    )
  }
	
	const isAnyFilterSelected = selectedPlaces.length > 0
		|| selectedAreas.length > 0
		|| selectedCompanies.length > 0
		|| selectedEquipmentModels.length > 0
		|| selectedFrequencies.length > 0
		|| selectedServiceTypes.length > 0
		|| selectedGroups.length > 0;

	return (
		<Box sx={styles.container}>
			<Box sx={styles.headerContainer}>
				<Box sx={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList sx={{ marginRight: '1rem' }} />
					{i18n.t('scheduledServicesServicesForSchedulingFilterModal.filter') as string}
					{ isAnyFilterSelected && <Box sx={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('scheduledServicesServicesForSchedulingFilterModal.clear') as string}</Box>}
				</Box>
				<IconButton onClick={() => props.closeModal()} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</Box>
			<Box sx={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipmentModels}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.equipmentModel')}
						data={equipmentModelsFormated}
						onSelectValue={handleInputChangeEquipmentsModels}
						valueSelected={selectedEquipmentModels}
						newSearchText={handleInputChangeSelectorEquipmentsModels}
						id="equipmentModel"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingGroups}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.groups')}
						data={groupsFormated}
						onSelectValue={handleInputChangeGroups}
						valueSelected={selectedGroups}
						newSearchText={handleInputChangeSelectorGroups}
						id="equipmentGroup"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.equipments')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						id="equipment"
						customizedOption={EquipmentOption}
						showDataWithoutComponentTextFilter={true}
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingServiceTypes}
						label={i18n.t('autocompleteModalFilterService.serviceTypes')}
						data={serviceTypesFormated}
						onSelectValue={handleInputChangeServiceTypes}
						valueSelected={selectedServiceTypes}
						newSearchText={handleInputChangeSelectorServiceTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingFrequencies}
						label={i18n.t('autocompleteModalFilterService.frequencies')}
						data={frequenciesFormated}
						onSelectValue={handleInputChangeFrequencies}
						valueSelected={selectedFrequencies}
						newSearchText={handleInputChangeSelectorFrequencies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						id="place"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						id="area"
						isMulti
					/>
				</FormControl>
				{ role !== 'contractor' && <FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingCompanies}
						label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.company')}
						data={companiesFormated}
						onSelectValue={handleInputChangeCompanies}
						valueSelected={selectedCompanies}
						newSearchText={handleInputChangeSelectorCompanies}
						id="company"
						isMulti
					/>
				</FormControl>}
				<FormControl variant="standard" fullWidth margin='normal'>
					<FormControlLabel
						control={<Switch checked={isStatusChecked(EServiceStatus.noService)} onChange={e => handleChangeStatus(EServiceStatus.noService, e.target.checked)} />}
						label={i18n.t(`scheduledServicesServicesForSchedulingFilterModal.noService`) as string}
					/>
					<FormHelperText>{i18n.t(`scheduledServicesServicesForSchedulingFilterModal.noServiceHelperText`) as string}</FormHelperText>
					<FormControlLabel
						control={<Switch checked={isStatusChecked(EServiceStatus.valid)} onChange={e => handleChangeStatus(EServiceStatus.valid, e.target.checked)} />}
						label={i18n.t(`scheduledServicesServicesForSchedulingFilterModal.valid`) as string}
					/>
					<FormHelperText>{i18n.t(`scheduledServicesServicesForSchedulingFilterModal.validHelperText`) as string}</FormHelperText>
					<FormControlLabel
						control={<Switch checked={isStatusChecked(EServiceStatus.overdue)} onChange={e => handleChangeStatus(EServiceStatus.overdue, e.target.checked)} />}
						label={i18n.t(`scheduledServicesServicesForSchedulingFilterModal.overdue`) as string}
					/>
					<FormHelperText>{i18n.t(`scheduledServicesServicesForSchedulingFilterModal.overdueHelperText`) as string}</FormHelperText>
				</FormControl>
				
				<FormControl variant="standard" fullWidth margin='normal'>
					{i18n.t('scheduledServicesServicesForSchedulingFilterModal.expirationDate') as string }
					<FormHelperText>{i18n.t(`scheduledServicesServicesForSchedulingFilterModal.expirationDateHelperText`) as string}</FormHelperText>
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterService.from') as string}
						value={startDate && new Date(startDate)}
						onChange={date => setStartDate(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', }, }}
						sx={{ marginTop: '5px'}}
					/>
			
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterService.to') as string}
						value={endDate && new Date(endDate)}
						onChange={date => setEndDate(date ? date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', }, }}
						sx={{ marginTop: '5px'}}
					/>
				</FormControl>
				
			</Box>
			<Box sx={styles.footerContainer}>
				<Box
					onClick={() => props.closeModal()}
					sx={styles.buttonCancel}
				>
					{i18n.t('scheduledServicesServicesForSchedulingFilterModal.cancel') as string}
				</Box>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					sx={styles.button}
				>
					{i18n.t('scheduledServicesServicesForSchedulingFilterModal.ok') as string}
				</Button>
			</Box>
		</Box>
	);
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
  headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: '10px',
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	},
	avatarSmallText: {
    fontSize: '0.75rem',
    width: '3rem',
    height: '3rem',
    marginLeft: '0.25rem',
  },
  avatar: {
    width: '3rem',
    height: '3rem',
    marginLeft: '5px',
  },
}

export default ServicesForSchedulingFiltersModal;
